import { capitalize } from 'lodash'
import { Dispatch, SetStateAction } from 'react'
import { getAssetTree } from './apis'
import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'

export const liveHeaderHeight = 35

export const bigPadding = 170

export function getAssetLink(path: string): string {
    return `./#/${QUALITY_MONITORING_URL}/${path}`
}

export const QUALITY_MONITORING_URL = 'quality-monitoring'
export const FACTORY_CONFIG_ID = 'factory-config' as const
export const PRODUCT_CONFIG_ID = 'product-config' as const

export function getColorFromResult(grade: number): string {
    if (grade === 0) return RATINGS_COLORS[4]
    if (grade <= 25) return RATINGS_COLORS[3]
    if (grade <= 50) return RATINGS_COLORS[2]
    if (grade <= 75) return RATINGS_COLORS[1]
    if (grade > 75) return RATINGS_COLORS[0]
}

export const RATINGS_TEXT = ['excelent', 'good', 'regular', 'bad', 'critical'] as const
export const RATINGS_COLORS = ['#009b75', '#92c600', '#f0c838', '#f89300', '#c43535'] as const

export const ACTION_PLAN_STATUS = {
    PENDING: 'pending',
    DONE: 'done'
} as const

export const ANALYSIS_TYPES = {
    ICC: 'icc',
    ICP: 'icp',
    ICM: 'icm'
} as const

export const ANALYSIS_STAGES = {
    GENERAL_INFO: 'general information',
    RATING: 'rating',
    RESULT: 'result'
} as const

export const isProduct = (asset: string): boolean => asset === 'product'

export function updateAssetTreeState(
    responseStatus: number,
    assetType?: AssetType,
    setAssetTree?: Dispatch<SetStateAction<unknown>>
): void {
    if (responseStatus === 200) {
        getAssetTree(assetType)
            .then(response => {
                setAssetTree(response)
            })
            .catch(() => globalNotification.error(i18n('Error retrieving data')))
    }
}
export function handleResponse(
    postResponse: Response,
    contentType: AssetConfigDialogContentType | 'line' | 'analysis' | 'stopped line'
): void {
    if (postResponse.status === 200) globalNotification.success(`${capitalize(i18n(contentType))} ${i18n('Saved')}`)
    else globalNotification.error(`Error ${postResponse.status}: ${postResponse.statusText}`)
}

export const RATING_TYPES = ['packaging', 'appearance', 'texture', 'taste'] as const

export function getAnalysisTypeFromParams(urlParams: string[]): AnalysisTypes | '' {
    const types = Object.values(ANALYSIS_TYPES) as string[]

    return urlParams.reduce((acc, param) => {
        if (types.includes(param)) acc = param

        return acc
    }, '') as AnalysisTypes | ''
}

export function userFilter(userInfo: { id: number }, selectedUsers: UserData[]): boolean {
    if (selectedUsers.filter(user => user && user.value === userInfo.id).length) {
        return false
    }

    return true
}
